module.exports = __webpack_public_path__ + "static/media/full-star.031678e1.svg";